<template>
    <div class="calendar-info-panel">
        <!-- 当下年月日时辰信息 -->
        <div class="calendar-info-date-box dsp-flex">
            <div class="com-calendar-info-date calendar-info-date">
                <p class="text-date">{{calendarInfo.y}}年{{calendarInfo.m}}月</p>
                <div class="com-calendar-info-day">
                    <span class="text-day">{{calendarInfo.d}}</span>
                </div>
                <div class="com-calendar-info-lunar">
                    <span class="text-lunar">{{calendarInfo.date}}</span>
                </div>
            </div>
            <div class="calendar-info-week">
                <p>{{calendarInfo.week}}</p>
            </div>
            <div class="calendar-info-sizhu dsp-flex">
                <div v-for="(sizhuData, index) in calendarInfo.sizhu" class="sizhu-item">
                    <span class="title">{{sizhuData.text}}</span>
                    <span class="sizhu-item-span" v-bind:class="{'sizhu-item-span-b': index == 3, 'colume-item-gray': parseInt(settingConfigData.showColor) == 0}" @click="clickSiZhu(index)">
                        <span v-if="index == 3" class="arrow arrow-up"><i class="iconfont icon-up"></i></span>
                        <span v-if="index == 3" class="arrow arrow-down"><i class="iconfont icon-down"></i></span>
                        <span class="gz" v-bind:class="'wd-' + sizhuData.gan.propXingEn">{{sizhuData.gan.text}}</span>
                        <span class="gz" v-bind:class="'wd-' + sizhuData.zhi.propXingEn">{{sizhuData.zhi.text}}</span>
                    </span>
                </div>
            </div>
            <div class="calendar-info-jieqi">
                <p v-for="jieqiText in calendarInfo.jieqi">{{jieqiText}}</p>
                <p>
                    <span class="calendar-info-btn calendar-info-btn-b" @click="clickCollate">起盘</span>
                    <!-- <span class="calendar-info-btn calendar-info-btn-g">写日记</span> -->
                </p>
            </div>
        </div>

        <!-- 宜忌 -->
        <div class="calendar-info-yiji" v-if="curYiJiData && curYiJiData.yi && curYiJiData.ji">
            <div class="calendar-info-yi clearfix">
                <div class="calendar-info-yi-icon">
                    <i class="iconfont icon-yi"></i>
                </div>
                <div class="calendar-info-yi-list">
                    <span v-for="yiData in curYiJiData.yi">{{yiData}}</span>
                </div>
            </div>
            <div class="calendar-info-ji clearfix">
                <div class="calendar-info-yi-icon">
                    <i class="iconfont icon-ji"></i>
                </div>
                <div class="calendar-info-yi-list">
                    <span v-for="jiData in curYiJiData.ji">{{jiData}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MIX } from '../../modules/utils';

export default {
    name: 'CalendarInfo',
    computed: {
        calendarInfo() {
            return this.$store.state.calendar.calendarInfo;
        },
        curYiJiData() {
            return this.$store.state.calendar.curYiJiData;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    methods: {
        clickCollate() {
            MIX.trackButtonClicked('calendar_qipan');
            var me = this;
            this.$store.state.calendar.detailFromPage = 'calendar';
            this.$store.dispatch('calendar/startCalendarCollate', {
                cb: function(){
                    me.$router.replace('/detail/calendar/00000');
                }
            });
        },
        clickSiZhu(index) {
            if(index == 3) {
                this.$store.dispatch('calendar/initCalendarHour')
            }
        }
    }
}
</script>